<template>
  <el-form :model="formData" v-bind="$attrs" @submit.native.prevent>
    <el-form-item label="筛选内容" required>
        <div class="screen-item">
            <el-radio-group 
                :value="screenType" 
                @input="(v)=>handleScreenTypeChange(v, screenType)"
            > 
                <el-radio-button 
                    v-for="item in screenTypeList" 
                    :key="item.value"
                    :label="item.value"
                > {{ item.label }} </el-radio-button>
            </el-radio-group>
        </div>
        <div class="screen-item"> 
            <el-button plain type="primary" @click="handleBatchSelectClick"><span class="p20">批量选择</span></el-button> 
        </div>
        <div class="screen-item screen-content"> 
            <div class="screen-content-item" v-loading="loading">
                <div class="top-search header">
                    <i class="el-icon-search"/>
                    <input 
                        type="text" 
                        v-model="keyWord" 
                        placeholder="输入名称关键词/精准ID后回车搜索"
                        @keydown.enter="handleKeydownEnter"
                    />
                    <i v-if="keyWord" @click="keyWord = ''" class="el-icon-close close"/>
                </div>
                <div class="check-all" v-show="list.length">
                    <el-button type="text" @click="()=>handleIsCheckAll(true, list)">全选</el-button>
                    <el-button type="text" @click="()=>handleIsCheckAll(false, list)">取消全选</el-button> 
                </div>
                <div class="result-list">
                    <p v-show="!list.length" class="no-data">暂无数据</p>
                    <div class="result-list-box">
                        <div class="result-list-item" v-for="item in list" :key="item.id">
                            <el-checkbox 
                            :value='checkIdList.includes(item.id)' 
                            @change="(data)=>handleIsCheckAll(data, [item])">
                                {{item.name}}
                            </el-checkbox>
                        </div>
                    </div>
                </div>
                <el-pagination
                    class="m10"
                    v-show="list.length"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[30, 50, 80, 100]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :pager-count="5"
                    :total="total">
                </el-pagination>
            </div>
            <div class="screen-content-item">
                <div class="header check-top">
                    <div class="check-num">已选（{{checkList.length}}）</div>
                    <div class="check-null"><el-button type="text" @click="checkList = []"><span style="color:red">清空</span></el-button></div>
                </div>
                <div class="check-list">
                    <p v-show="!checkList.length" class="no-data">请筛选数据并勾选</p>
                    <div class="check-list-item" v-for="item in checkList" :key="item.id">
                        <span>{{item.name}}</span>
                        <i class="el-icon-close" @click="()=>handleCheckData(false, item)"/>
                    </div>
                </div>
            </div>
        </div>
    </el-form-item>
  </el-form>
</template>

<script>
import { SCREEN_TYPE, SCREEN_TYPE_LIST, PLAT_SCREEN_TYPE_LIST } from './constant';
import { getAdjustmentConditionListApi } from '@/api'
import { screenBatchSelectModal, messageTipModal } from '../../modal'
import { differenceBy, concat } from 'lodash'
// 101191069 101080671 
// 101191130 101194806 
// 101216022 101670102 
// 101061938 101148296 
// 101183403 101006342
// 101242586
// 
export default {
    name: 'ScreenForm',
    props: [ 'platId', 'defaultFormData' ],
    inject: [ 'validFormItem', ],
    data() {
        return {
            screenType: this.defaultFormData.screenType, //SCREEN_TYPE.PLAN,
            keyWord: '',//检索关键词
            formData: {},
            checkList: this.defaultFormData.checkList,
            loading: false,
            pageNum: 1,
            pageSize: 30,
            total: 0,
            list: []
        }
    },
    computed: {
        checkIdList() {
            return this.checkList.map(v=>v.id)
        },
        screenTypeList() {
            return PLAT_SCREEN_TYPE_LIST[this.platId] || []
        }
    },
    watch: {
        screenType: {
            handler(val, oldVal) {
               this.$emit('update:screenType', val)
            },
            immediate: true,
        }
    },
    created() {
        const fn = (cb)=> {
            cb(this.checkList, ()=> {
                this.screenType = SCREEN_TYPE.PLAN;
                this.resetScreenData()
            })
        };
        this.$bus.$on('validSelectData', fn);
        this.$once('hook:beforeDestroy', () => {
            this.$bus.$off('validSelectData', fn)
        });
    },
    methods: { 
        handleScreenTypeChange(val, oldVal) {
            this.screenType = val;
            if (!this.checkList.length) {
                this.$bus.$emit('screenTypeChange', val)
                this.resetScreenData()
                return;
            }
            this.$confirm('切换将清空所选的全部数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.$bus.$emit('screenTypeChange', val)
               this.resetScreenData()
            }).catch(() => { 
                this.$bus.$emit('screenTypeChange', oldVal)
                this.screenType = oldVal;
            });
        },
        resetScreenData() {
            this.checkList = [];
            this.keyWord = '';
            this.list = [];
            this.pageNum = 1;
        },
        // 批量选择
        handleBatchSelectClick() {
            const onSubmit = async (textlist, callback)=> {
                
                try {
                    if (!textlist.length) {
                        this.$message.error('请输入内容');
                        return
                    }
                    const params = {
                        plat_id: this.platId,
                        search_type: this.screenType,
                        batch_search: textlist
                    };
                    const { data }= await getAdjustmentConditionListApi(params);
                    if (data?.err_list?.length) {
                        delErrList({
                            tip: '未找到以下内容，请核实，是否需要剔除未找到的内容?',
                            list: data.err_list,
                            onOk: ()=> {
                                this.handleIsCheckAll(true, data.list);
                                vm.close()
                            }
                        });
                        return
                    };
                    this.handleIsCheckAll(true, data.list);
                    vm.close();
                } catch (error) {
                    console.log('批量选择错误', error);
                    this.$message.error(error.info || error.message)
                }finally {
                    callback()
                }
            }
            const { vm, delErrList } = screenBatchSelectModal({
                cbs: {
                    onSubmit
                }
            })
        },
        handleCheckData(check, data) {
            if (check) {
                if (!this.checkIdList.includes(data.id)) {
                    this.checkList.push(data)
                }
            }else {
                this.checkList =this.checkList
                .filter(v=>v.id !== data.id);
            }
        },
        handleKeydownEnter() {
            if (!this.keyWord) {
                this.$message.error('检索内容不可为空')
                return
            }
            this.getAdjustmentConditionList()
        },
        async getAdjustmentConditionList() {
            try {
                this.loading = true;
                const params = {
                    plat_id: this.platId,
                    search_type: this.screenType,
                    search: this.keyWord,
                    pn: this.pageNum,
                    rn: this.pageSize,
                };
                const { data } = await getAdjustmentConditionListApi(params);
                this.list = data.list;
                this.total = data.totalCnt;
            } catch (error) {
                console.log('刷选发生错误', error);
                this.$message.error(error.info || error.message)
            }finally {
                this.loading = false
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNum = 1;
            this.getAdjustmentConditionList()
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getAdjustmentConditionList()
        },
        handleIsCheckAll(isAll, list) {
            const nList = concat(differenceBy(this.checkList, list, 'id'), list); ;
           if (
                (
                    this.screenType === SCREEN_TYPE.PLAN && nList.length>5000 ||
                    this.screenType === SCREEN_TYPE.ACCOUNT && nList.length>30
                ) && isAll
            ) {
                if (this.screenType === SCREEN_TYPE.PLAN) {
                    this.$message.error('每次最多操作5000个计划，超出5000个请添加新任务处理.');
                }else {
                    this.$message.error('每次最多操作30个账户，超出30个请添加新任务处理.');
                }
                return
            };
            list.map(v=> {
                this.handleCheckData(isAll, v)
            })
        },
        async validateFn() {
            if (!this.checkIdList.length) {
                this.validFormItem('筛选-筛选内容：筛选内容不能为空');
                return Promise.reject(false);
            }
            return { 
                search_type: this.screenType,
                condition: [ ...this.checkIdList ] 
             } 
        },
    }
}
</script>

<style lang="scss" scoped>
.screen-item {
    margin-bottom: 8px;
}
.no-data {
    text-align: center;
    font-size: 12px;
    color: #999;
    padding-top: 30px;
}
.screen-content {
    display: inline-flex;
    border: 1px solid #ccc;
    min-width: 900px;
    width: 100%;
    height: 400px;
    &-item {
        width: 50%;
        height: 100%;
        &:first-child {
            border-right: 1px solid #ccc;
        }
        .header {
            height: 40px;
            border-bottom: 1px solid #ccc;
        }
        .top-search {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            input {
                border: none;
                outline: none;
                flex: 1;
                margin: 0 6px;
            }
            .close {
                cursor: pointer;
            }
        }
        .check-all {
            font-size: 12px;
            margin-left: 8px;
            color: #409eff;
        }
        .result-list {
            height: 260px;
            overflow: auto;
            padding: 0 8px;
            &-box {
                display: inline-block;
                min-width: 100%;
            }
            &-item {
                min-width: 100%;
                border-bottom: 1px solid #e6e6e6;
                display: inline-block;
                // &::v-deep{
                //     .el-checkbox {
                //         // border-bottom: 1px solid #e6e6e6;
                //     }
                // }
            }
        }
        .check-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 8px;
            .check-num {
                font-size: 12px;
                font-weight: bold;
            }
        }
        .check-list {
            height: 350px;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 0 8px;
            font-size: 12px;
            color: #606266;
            &-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #e6e6e6;
                line-height: 1.5;
                padding: 6px 0;
                i {
                    color: red;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>